const WA_TOKEN    = process.env.REACT_APP_WA_TOKEN;
const WA_PHONE_ID = process.env.REACT_APP_WA_PHONE_ID;
const WA_API_URL  = `https://graph.facebook.com/v21.0/${WA_PHONE_ID}/messages`;

// Nömrəni +994XXXXXXXX formatına gətir
function normalizePhone(phone) {
  if (!phone) return null;
  let p = phone.replace(/\D/g, '');
  if (p.startsWith('0')) p = '994' + p.slice(1);
  if (!p.startsWith('994') && p.length === 9) p = '994' + p;
  return p;
}

// ── Yeni rezervasiya bildirişi ────────────────────────────────────────────────
export async function sendNewBookingAlert(managerPhone, booking) {
  const to = normalizePhone(managerPhone);
  if (!to || !WA_TOKEN || !WA_PHONE_ID) return;

  const date    = booking.reservation_date || '';
  const time    = (booking.reservation_time || '').slice(0, 5);
  const name    = booking.contact_name || booking.guest_name || 'Naməlum';
  const phone   = booking.contact_phone || '';
  const guests  = booking.party_size || booking.guest_count || '—';
  const table   = booking.table_number ? `Masa ${booking.table_number}` : '';
  const code    = booking.booking_code || booking.id?.slice(0, 8)?.toUpperCase() || '';

  const text = [
    `🔔 *Yeni Rezervasiya Sorğusu*`,
    ``,
    `👤 ${name}${phone ? `  📞 ${phone}` : ''}`,
    `📅 ${date}  🕐 ${time}`,
    `🪑 ${guests} nəfər${table ? `  |  ${table}` : ''}`,
    code ? `🔖 #${code}` : '',
    ``,
    `Paneldən qəbul/rədd edin: https://business.cafegoo.com/bookings`,
  ].filter(Boolean).join('\n');

  try {
    const res = await fetch(WA_API_URL, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${WA_TOKEN}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        messaging_product: 'whatsapp',
        to,
        type: 'template',
        template: {
          name: 'booking_notification',
          language: { code: 'en' },
          components: [{
            type: 'body',
            parameters: [
              { type: 'text', text: name },
              { type: 'text', text: phone || '—' },
              { type: 'text', text: date || '—' },
              { type: 'text', text: time || '—' },
              { type: 'text', text: String(guests) },
              { type: 'text', text: table || '—' },
            ],
          }],
        },
      }),
    });
    const json = await res.json();
    console.log('[WA] response:', JSON.stringify(json));
  } catch (err) {
    console.error('[WA] send error:', err);
  }
}

// ── Rezervasiya qəbul/rədd bildirişi ─────────────────────────────────────────
export async function sendBookingStatusAlert(managerPhone, booking, status) {
  const to = normalizePhone(managerPhone);
  if (!to || !WA_TOKEN || !WA_PHONE_ID) return;

  const name   = booking.contact_name || booking.guest_name || 'Naməlum';
  const phone  = booking.contact_phone || '—';
  const date   = booking.reservation_date || '—';
  const time   = (booking.reservation_time || '').slice(0, 5) || '—';
  const guests = String(booking.party_size || booking.guest_count || '—');
  const table  = booking.table_number ? `Masa ${booking.table_number}` : '—';

  try {
    const res = await fetch(WA_API_URL, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${WA_TOKEN}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        messaging_product: 'whatsapp',
        to,
        type: 'template',
        template: {
          name: 'booking_notification',
          language: { code: 'en' },
          components: [{
            type: 'body',
            parameters: [
              { type: 'text', text: name },
              { type: 'text', text: phone },
              { type: 'text', text: date },
              { type: 'text', text: time },
              { type: 'text', text: guests },
              { type: 'text', text: table },
            ],
          }],
        },
      }),
    });
    const json = await res.json();
    console.log('[WA] status response:', JSON.stringify(json));
  } catch (err) {
    console.error('[WA] send error:', err);
  }
}
